import React from 'react';
import PropTypes from 'prop-types';
import { FaBed, FaPlus } from 'react-icons/fa';
import { Button } from 'components/common';

const StarterHotel = ({ setShowModalHotel }) => (
  <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-py-12 tw-px-6">
    <span
      className="tw-flex tw-items-center tw-justify-center tw-w-16 tw-h-16 tw-rounded-2xl tw-mb-4 tw-text-white"
      style={{ backgroundImage: 'linear-gradient(135deg, #8b5cf6, #6d28d9)', boxShadow: '0 8px 20px rgba(109,40,217,0.30)' }}
    >
      <FaBed size={26} />
    </span>
    <h3 className="tw-text-slate-800 tw-font-semibold tw-text-lg tw-mb-1">Hotel Booking</h3>
    <p className="tw-text-slate-500 tw-mb-4 tw-max-w-md">Book a hotel for the trip.</p>
    <Button size="sm" variant="primary" leftIcon={FaPlus} onClick={() => setShowModalHotel(true)}>Book a hotel now</Button>
  </div>
);

StarterHotel.propTypes = {
  setShowModalHotel: PropTypes.func.isRequired,
};

export default StarterHotel;
